import React, { PureComponent } from 'react';
import Loader from "../../../components/Loader";
import ProductRatesBlock from "./ProductRatesBlock";
import HeaderDiv from "../../../components/HeaderDiv";
import { styled } from '@mui/system';
import { colors } from "../../../theme";
import MessageCard from "../../../components/Cards/MessageCard";
import * as dates from "@simplybenefits/sb-dates";
import * as Services from "../../../services";
import FormModal from "../../../components/Modals/FormModal";
import Text from "../../../components/Text";
import DateInput from "../../../components/TextFields/DateInput";
const ContentBlock = styled('div')({
  backgroundColor: colors.surface,
  boxShadow: '0 1px 2px rgba(0, 0, 0, .15)',
  display: 'block',
  margin: 'auto auto 30px auto',
  padding: '30px',
  position: 'relative',
  zIndex: 4
});
class SpecialityProductRates extends PureComponent {
  state = {
    rates: null,
    effectiveDate: dates.getUTC(new Date(), 'YYYY/MM/DD')
  };
  async componentDidMount() {
    const rates = await this.props.getSpecialityProductRates();
    if (rates) {
      this.setState({
        rates
      });
    } else {
      this.setState({
        rates: {}
      });
    }
  }
  _saveValueInState = (specialityProductID, field, value) => {
    this.setState({
      rates: {
        ...this.state.rates,
        [specialityProductID]: {
          ...this.state.rates[specialityProductID],
          specialityProductID,
          [field]: value
        }
      }
    });
  };
  _validateEffectiveDate = async () => {
    let effectiveDateError = await Services.validateInput('effectiveDate', this.state.effectiveDate);
    const startOfMonth = dates.getStartOfMonth();
    const effectiveDateUTC = dates.getUTC(this.state.effectiveDate);
    if (effectiveDateUTC < startOfMonth) {
      effectiveDateError = 'Rate changes can only be backed dated to the start of the month.';
    }
    await this.setState({
      effectiveDateError
    });
    if (effectiveDateError) {
      return false;
    }
    return true;
  };
  _saveRates = async () => {
    // if it's the master site, make sure we ask for an effective date
    const effectiveDateValid = await this._validateEffectiveDate();
    if (!effectiveDateValid) {
      return null;
    }
    await this.props.saveSpecialityProductRates(this.state.rates, dates.getUTC(this.state.effectiveDate));
    this.setState({
      effectiveDateModalOpen: false
    });
    return null;
  };
  render() {
    if (!this.state.rates) {
      return /*#__PURE__*/React.createElement(Loader, {
        whitelabel: this.props.whitelabel
      });
    }
    return /*#__PURE__*/React.createElement(ContentBlock, null, /*#__PURE__*/React.createElement(HeaderDiv, null, this.props.step >= 4 || this.props.isAccountLive ? /*#__PURE__*/React.createElement(MessageCard, {
      title: "Speciality Product Rates",
      subtitle: "For each product listed below, you can either view or set the product rates. If a product is invoiced by Census, you need to establish solo, duo, and family rates for each class that has the product enabled. Alternatively, if you choose to invoice by Volume, you must specify the billable volume and the corresponding rate for each division.",
      btn: true,
      btn2: true,
      btnName: "SAVE RATES",
      btnOnClick: () => {
        if (this.props.isAccountLive) {
          this.setState({
            effectiveDateModalOpen: true
          });
        } else {
          this.props.saveSpecialityProductRates(this.state.rates, null);
        }
      },
      btnName2: "Download PDF",
      btnOnClick2: () => this.props.downloadRatesPdf("PrivateLabelRatesSummary", "Private-Label-Rates-Summary.pdf", {
        accountID: this.props?.currentAccountMeta?.accountID || null,
        quoteID: this.props.quote?.quoteID || null
      })
    }) : /*#__PURE__*/React.createElement(MessageCard, {
      title: "Speciality Product Rates",
      subtitle: "For each product listed below, you can either view or set the product rates. If a product is invoiced by Census, you need to establish solo, duo, and family rates for each class that has the product enabled. Alternatively, if you choose to invoice by Volume, you must specify the billable volume and the corresponding rate for each division. Use the buttons below to save and submit the rates.",
      btn: true,
      btnName: "SUBMIT RATES",
      btnOnClick: () => this.props.submitSpecialityProductRates(this.state.rates, null),
      btn2: true,
      btnName2: "SAVE RATES",
      btnOnClick2: () => this.props.saveSpecialityProductRates(this.state.rates, null)
    })), Object.keys(this.state.rates).map(specialityProductID => {
      const privateLabelID = this.state.rates[specialityProductID].privateLabelID;
      const productMeta = this.props.specialityProductMetaConfigs[privateLabelID].products[specialityProductID];
      const productRates = this.state.rates[specialityProductID];
      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/jsx-key
        React.createElement(ProductRatesBlock, {
          productRates: productRates,
          name: productMeta.name,
          carrier: productMeta.carrier,
          whitelabel: this.props.whitelabel,
          isMasterSite: this.props.isMasterSite,
          language: this.props.language,
          saveValueInState: this._saveValueInState
        })
      );
    }), /*#__PURE__*/React.createElement(FormModal, {
      open: this.state.effectiveDateModalOpen,
      close: () => this.setState({
        effectiveDateModalOpen: false
      }),
      title: "Set Effective Date",
      onSave: this._saveRates,
      saveButtonText: "Submit"
    }, /*#__PURE__*/React.createElement(Text, {
      medium: true
    }, "Please provide the date you would like the change(s) to be effective:"), /*#__PURE__*/React.createElement(DateInput, {
      label: "Effective Date",
      value: this.state.effectiveDate,
      onChange: e => {
        this.setState({
          effectiveDate: e.target.value
        });
      },
      error: Boolean(this.state.effectiveDateError),
      helperText: this.state.effectiveDateError,
      fullWidth: true,
      required: true
    }), /*#__PURE__*/React.createElement(Text, {
      medium: true,
      margin: "10px 0 0 0"
    }, "By clicking Submit below, the changes made will be applied and effective on the date provided above. Back dated changes will have adjustments applied using current rates."), this.props.loading && /*#__PURE__*/React.createElement(Loader, {
      whitelabel: this.props.whitelabel,
      customImageStyle: {
        top: '50%'
      }
    })), this.props.loading && /*#__PURE__*/React.createElement(Loader, {
      whitelabel: this.props.whitelabel
    }));
  }
}
export default SpecialityProductRates;